"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Highlighter = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Highlighter_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.95 11.563.94-.94a1.56 1.56 0 0 1 1.104-.458h1.166l4.804-4.804a.121.121 0 0 0 0-.172l-3.398-3.398a.121.121 0 0 0-.171 0L6.59 6.595v1.167c0 .413-.164.81-.457 1.103m.816 2.698L5.192 9.806l.941-.941M2.975 12.23l-1.528 2.013h2.89l.314-.337-1.676-1.676Zm3.578.351-2.378-2.379a.56.56 0 0 1 0-.792l1.251-1.252a.56.56 0 0 0 .164-.396V6.413a.56.56 0 0 1 .165-.396l4.933-4.933a1.121 1.121 0 0 1 1.585 0l3.399 3.398a1.121 1.121 0 0 1 0 1.586l-4.934 4.933a.56.56 0 0 1-.396.165H8.994a.56.56 0 0 0-.397.164L7.346 12.58a.56.56 0 0 1-.793 0Zm-3.227-1.414 2.332 2.332a.56.56 0 0 1 .014.778l-.733.788a.56.56 0 0 1-.41.178H.561a.56.56 0 0 1-.447-.9l2.368-3.119a.56.56 0 0 1 .843-.057Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Highlighter_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Highlighter;
exports["default"] = _default;